/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DocBits - API
 * DocBits - API
 * OpenAPI spec version: 11.97.2
 */
import type {
  AssignWithEmailDocumentAssignWithEmailDocIdPostParams,
  BodyAnnotateDocumentDocumentAnnotationAnnotateDocumentPost,
  BodyAppendFilesToDocumentDocumentAppendPost,
  BodyApplyScriptDocumentScriptApplyPost,
  BodyApplyScriptOnDocumentDocumentScriptApplyToDocumentPost,
  BodyApproveOrRejectDocumentApproveOrRejectDocIdPost,
  BodyAssignDocumentAssignDocIdPost,
  BodyAssignDocumentsDocumentAssignPost,
  BodyAssignWithEmailDocumentAssignWithEmailDocIdPost,
  BodyAutoAccountingDashboardDocumentAccountingDashboardPost,
  BodyClassifyDocumentDocumentClassifyPost,
  BodyClearExtractedDataCacheDocumentExtractionCacheClearPost,
  BodyCreateDashboardExportRequestDocumentExportsRequestsPost,
  BodyDeleteDocumentsDocumentDeleteDocumentsDelete,
  BodyEditAnnotationDocumentAnnotationEditAnnotationPut,
  BodyEditDocumentStampDocumentAnnotationEditDocumentStampPut,
  BodyExportDashboardDataDocumentExportsDashboardPost,
  BodyExtractionResultDocumentExtractionResultPost,
  BodyExtractionResultV2DocumentExtractionResultV2Post,
  BodyGenerateThumbnailsDocumentThumbnailsPost,
  BodyGetAnnotationsDocumentAnnotationGetAnnotationsPost,
  BodyGetDocStatusXmlDocumentStatusXmlPost,
  BodyGetDocStatusXmlListDocumentStatusXmlListPost,
  BodyGetDocumentContentDocumentGetDocumentContentDocIdPost,
  BodyGetDocumentLogDocumentGetDocumentLogDocIdPost,
  BodyGetDocumentTypeFilterKeysDocumentFiltersDocumentTypesPost,
  BodyGetOcrDataDocumentGetOcrDataDocIdPost,
  BodyGetRelatedDocumentsDocumentRelatedPost,
  BodyMergeDocumentsDocumentMergePost,
  BodyNotifyRequisitionerDocumentNotifyRequisitionerPost,
  BodyProcessBase64DocumentProcessBase64Post,
  BodyProcessDocumentImportPost,
  BodyProcessDocumentProcessPost,
  BodyProcessDocumentsDocumentProcessDocumentsPost,
  BodyRemoveAnnotationDocumentAnnotationRemoveAnnotationDelete,
  BodyRestartDocumentsDocumentRestartPost,
  BodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost,
  BodySaveAndValidateDocumentSaveAndValidateDocIdPost,
  BodySetDocumentsStatusDocumentSetStatusDocIdPost,
  BodySetFieldValuesDocumentSetFieldsDocIdPost,
  BodySplitDocumentDocumentSplitPost,
  BodyStampOnDocumentDocumentAnnotationStampDocumentPost,
  BodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost,
  BodyUpdateDocumentUpdateDocIdPost,
  BodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost,
  BodyValidateAndExportDocumentValidateAndExportDocIdPost,
  CreateDashboardExportRequestDocumentExportsRequestsPostParams,
  DashboardDocumentDashboardsGetParams,
  DeleteDocumentDocumentDeleteDocIdDeleteParams,
  DocumentsListDocumentGetParams,
  DocumentsStatusDocumentStatusByIdDocIdGetParams,
  ExportDashboardDataDocumentExportsDashboardPostParams,
  FindDuplicatesDocumentDuplicatesGetParams,
  GetDashboardDocumentDashboardGetParams,
  GetDashboardExportLogsDocumentExportsLogsGetParams,
  GetDocStatusInfoDocumentGetDocStatusInfoDocIdGetParams,
  GetDocumentDocumentByIdDocIdGetParams,
  GetDocumentsByBatchIdDocumentGetDocumentsByBatchIdBatchIdGetParams,
  GetEnhancedDocumentErrorsDocumentErrorAnalyticsGetErrorsDocIdGet200,
  GetEnhancedDocumentErrorsDocumentErrorAnalyticsGetErrorsDocIdGetParams,
  GetErrorPatternsDocumentErrorAnalyticsAnalyticsErrorPatternsGet200,
  GetErrorPatternsDocumentErrorAnalyticsAnalyticsErrorPatternsGetParams,
  GetItemsFromDictionarySyncDocumentGetItemsFromDictionaryItemGetParams,
  GetMultipleDocumentsStatusDocumentStatusesGetParams,
  GetNextDocumentDocumentGetNextDocumentDocIdGetParams,
  GetProactiveAlertsDocumentErrorAnalyticsProactiveAlertsGet200,
  GetProactiveAlertsDocumentErrorAnalyticsProactiveAlertsGetParams,
  NextDocumentDocumentNextGetParams,
  ProcessBase64DocumentProcessBase64PostParams,
  ProcessDocumentImportPostParams,
  ProcessDocumentProcessPostParams,
  ProcessDocumentsDocumentProcessDocumentsPostParams,
  RebuildAccountingModelsDocumentAccountingRebuildPostParams,
  RestartDocumentRestartDocIdGetParams,
  RestartDocumentsDocumentRestartPostParams,
  RestartExportDocumentRestartExportDocIdGetParams,
  RestartExportDocumentsDocumentRestartExportDocumentsDocIdsGetParams,
  RestartExportWithStatusDocumentRestartExportWithStatusOrgIdGetParams,
  RestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPostParams,
  RetryDocumentFromStepDocumentErrorAnalyticsRetryFromStepDocIdPost200,
  RetryDocumentFromStepDocumentErrorAnalyticsRetryFromStepDocIdPostParams,
  SetStatusToValidationDocumentSetStatusToReadyForValidationDocIdGetParams,
} from '.././models';

import { customAxiosInstance } from '../../mutator/custom-axios-instance';

export const getDocument = () => {
  /**
   * @summary Get Annotations
   */
  const getAnnotationsDocumentAnnotationGetAnnotationsPost = (
    bodyGetAnnotationsDocumentAnnotationGetAnnotationsPost: BodyGetAnnotationsDocumentAnnotationGetAnnotationsPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyGetAnnotationsDocumentAnnotationGetAnnotationsPost.doc_id,
    );

    return customAxiosInstance<unknown>({
      url: `/document_annotation/get_annotations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Annotate Document
   */
  const annotateDocumentDocumentAnnotationAnnotateDocumentPost = (
    bodyAnnotateDocumentDocumentAnnotationAnnotateDocumentPost: BodyAnnotateDocumentDocumentAnnotationAnnotateDocumentPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyAnnotateDocumentDocumentAnnotationAnnotateDocumentPost.doc_id,
    );
    formUrlEncoded.append(
      `data`,
      bodyAnnotateDocumentDocumentAnnotationAnnotateDocumentPost.data,
    );

    return customAxiosInstance<unknown>({
      url: `/document_annotation/annotate_document`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Edit Annotation
   */
  const editAnnotationDocumentAnnotationEditAnnotationPut = (
    bodyEditAnnotationDocumentAnnotationEditAnnotationPut: BodyEditAnnotationDocumentAnnotationEditAnnotationPut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `annotation_id`,
      bodyEditAnnotationDocumentAnnotationEditAnnotationPut.annotation_id,
    );
    formUrlEncoded.append(
      `data`,
      bodyEditAnnotationDocumentAnnotationEditAnnotationPut.data,
    );

    return customAxiosInstance<unknown>({
      url: `/document_annotation/edit_annotation`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Stamp On Document
   */
  const stampOnDocumentDocumentAnnotationStampDocumentPost = (
    bodyStampOnDocumentDocumentAnnotationStampDocumentPost: BodyStampOnDocumentDocumentAnnotationStampDocumentPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyStampOnDocumentDocumentAnnotationStampDocumentPost.doc_id,
    );
    formUrlEncoded.append(
      `data`,
      bodyStampOnDocumentDocumentAnnotationStampDocumentPost.data,
    );

    return customAxiosInstance<unknown>({
      url: `/document_annotation/stamp_document`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Edit Document Stamp
   */
  const editDocumentStampDocumentAnnotationEditDocumentStampPut = (
    bodyEditDocumentStampDocumentAnnotationEditDocumentStampPut: BodyEditDocumentStampDocumentAnnotationEditDocumentStampPut,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyEditDocumentStampDocumentAnnotationEditDocumentStampPut.doc_id,
    );
    formUrlEncoded.append(
      `data`,
      bodyEditDocumentStampDocumentAnnotationEditDocumentStampPut.data,
    );

    return customAxiosInstance<unknown>({
      url: `/document_annotation/edit_document_stamp`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Remove Annotation
   */
  const removeAnnotationDocumentAnnotationRemoveAnnotationDelete = (
    bodyRemoveAnnotationDocumentAnnotationRemoveAnnotationDelete: BodyRemoveAnnotationDocumentAnnotationRemoveAnnotationDelete,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `annotation_id`,
      bodyRemoveAnnotationDocumentAnnotationRemoveAnnotationDelete.annotation_id,
    );

    return customAxiosInstance<unknown>({
      url: `/document_annotation/remove_annotation`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Enhanced error reporting with detailed DocFlow step information.

Replaces basic error response with comprehensive error context including:
- Which specific step failed
- Processing history and timeline
- Error categorization and suggested actions
- Retry recommendations and recovery options
 * @summary Get Enhanced Document Errors
 */
  const getEnhancedDocumentErrorsDocumentErrorAnalyticsGetErrorsDocIdGet = (
    docId: string,
    params: GetEnhancedDocumentErrorsDocumentErrorAnalyticsGetErrorsDocIdGetParams,
  ) => {
    return customAxiosInstance<GetEnhancedDocumentErrorsDocumentErrorAnalyticsGetErrorsDocIdGet200>(
      {
        url: `/document/error-analytics/get_errors/${docId}`,
        method: 'GET',
        params,
      },
    );
  };
  /**
 * Retry document processing from specific failed step.

Allows users to restart processing from the point of failure
rather than reprocessing the entire document.
 * @summary Retry Document From Step
 */
  const retryDocumentFromStepDocumentErrorAnalyticsRetryFromStepDocIdPost = (
    docId: string,
    params: RetryDocumentFromStepDocumentErrorAnalyticsRetryFromStepDocIdPostParams,
  ) => {
    return customAxiosInstance<RetryDocumentFromStepDocumentErrorAnalyticsRetryFromStepDocIdPost200>(
      {
        url: `/document/error-analytics/retry_from_step/${docId}`,
        method: 'POST',
        params,
      },
    );
  };
  /**
 * Get current proactive alerts for real-time error monitoring.

Returns active alerts from the proactive error detection system
that monitors patterns and triggers alerts when thresholds are exceeded.
 * @summary Get Proactive Alerts
 */
  const getProactiveAlertsDocumentErrorAnalyticsProactiveAlertsGet = (
    params: GetProactiveAlertsDocumentErrorAnalyticsProactiveAlertsGetParams,
  ) => {
    return customAxiosInstance<GetProactiveAlertsDocumentErrorAnalyticsProactiveAlertsGet200>(
      {
        url: `/document/error-analytics/proactive/alerts`,
        method: 'GET',
        params,
      },
    );
  };
  /**
 * Get error analytics for debugging and process optimization.

Provides insights into common error patterns, failure rates by step,
and trending issues for proactive resolution.
 * @summary Get Error Patterns
 */
  const getErrorPatternsDocumentErrorAnalyticsAnalyticsErrorPatternsGet = (
    params: GetErrorPatternsDocumentErrorAnalyticsAnalyticsErrorPatternsGetParams,
  ) => {
    return customAxiosInstance<GetErrorPatternsDocumentErrorAnalyticsAnalyticsErrorPatternsGet200>(
      {
        url: `/document/error-analytics/analytics/error_patterns`,
        method: 'GET',
        params,
      },
    );
  };
  /**
   * @summary Get Search Fields Catalog
   */
  const getSearchFieldsCatalogDocumentSearchFieldsGet = () => {
    return customAxiosInstance<unknown>({
      url: `/document/search/fields`,
      method: 'GET',
    });
  };
  /**
   * @summary Get Dashboard Export Logs
   */
  const getDashboardExportLogsDocumentExportsLogsGet = (
    params?: GetDashboardExportLogsDocumentExportsLogsGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/exports/logs`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Classify Document
   */
  const classifyDocumentDocumentClassifyPost = (
    bodyClassifyDocumentDocumentClassifyPost: BodyClassifyDocumentDocumentClassifyPost,
  ) => {
    const formData = new FormData();
    formData.append(`file`, bodyClassifyDocumentDocumentClassifyPost.file);
    formData.append(`org_id`, bodyClassifyDocumentDocumentClassifyPost.org_id);

    return customAxiosInstance<unknown>({
      url: `/document/classify`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };
  /**
   * @summary Process Documents
   */
  const processDocumentsDocumentProcessDocumentsPost = (
    bodyProcessDocumentsDocumentProcessDocumentsPost: BodyProcessDocumentsDocumentProcessDocumentsPost,
    params?: ProcessDocumentsDocumentProcessDocumentsPostParams,
  ) => {
    const formData = new FormData();
    if (bodyProcessDocumentsDocumentProcessDocumentsPost.source !== undefined) {
      formData.append(
        `source`,
        bodyProcessDocumentsDocumentProcessDocumentsPost.source,
      );
    }
    formData.append(
      `org_id`,
      bodyProcessDocumentsDocumentProcessDocumentsPost.org_id,
    );
    if (
      bodyProcessDocumentsDocumentProcessDocumentsPost.sub_org_id !== undefined
    ) {
      formData.append(
        `sub_org_id`,
        bodyProcessDocumentsDocumentProcessDocumentsPost.sub_org_id,
      );
    }
    if (
      bodyProcessDocumentsDocumentProcessDocumentsPost.priority !== undefined
    ) {
      formData.append(
        `priority`,
        bodyProcessDocumentsDocumentProcessDocumentsPost.priority.toString(),
      );
    }
    if (
      bodyProcessDocumentsDocumentProcessDocumentsPost.metadata !== undefined
    ) {
      formData.append(
        `metadata`,
        bodyProcessDocumentsDocumentProcessDocumentsPost.metadata,
      );
    }
    if (
      bodyProcessDocumentsDocumentProcessDocumentsPost.doc_type !== undefined
    ) {
      formData.append(
        `doc_type`,
        bodyProcessDocumentsDocumentProcessDocumentsPost.doc_type,
      );
    }
    bodyProcessDocumentsDocumentProcessDocumentsPost.files.forEach((value) =>
      formData.append(`files`, value),
    );
    if (
      bodyProcessDocumentsDocumentProcessDocumentsPost.assign_to !== undefined
    ) {
      formData.append(
        `assign_to`,
        bodyProcessDocumentsDocumentProcessDocumentsPost.assign_to,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/process_documents`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
    });
  };
  /**
   * @summary Process
   */
  const processDocumentImportPost = (
    bodyProcessDocumentImportPost: BodyProcessDocumentImportPost,
    params?: ProcessDocumentImportPostParams,
  ) => {
    const formData = new FormData();
    if (bodyProcessDocumentImportPost.source !== undefined) {
      formData.append(`source`, bodyProcessDocumentImportPost.source);
    }
    if (bodyProcessDocumentImportPost.org_id !== undefined) {
      formData.append(`org_id`, bodyProcessDocumentImportPost.org_id);
    }
    if (bodyProcessDocumentImportPost.sub_org_id !== undefined) {
      formData.append(`sub_org_id`, bodyProcessDocumentImportPost.sub_org_id);
    }
    if (bodyProcessDocumentImportPost.priority !== undefined) {
      formData.append(
        `priority`,
        bodyProcessDocumentImportPost.priority.toString(),
      );
    }
    if (bodyProcessDocumentImportPost.metadata !== undefined) {
      formData.append(`metadata`, bodyProcessDocumentImportPost.metadata);
    }
    if (bodyProcessDocumentImportPost.doc_type !== undefined) {
      formData.append(`doc_type`, bodyProcessDocumentImportPost.doc_type);
    }
    formData.append(`file`, bodyProcessDocumentImportPost.file);

    return customAxiosInstance<unknown>({
      url: `/document/import`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
    });
  };
  /**
   * @summary Process
   */
  const processDocumentProcessPost = (
    bodyProcessDocumentProcessPost: BodyProcessDocumentProcessPost,
    params?: ProcessDocumentProcessPostParams,
  ) => {
    const formData = new FormData();
    if (bodyProcessDocumentProcessPost.source !== undefined) {
      formData.append(`source`, bodyProcessDocumentProcessPost.source);
    }
    if (bodyProcessDocumentProcessPost.org_id !== undefined) {
      formData.append(`org_id`, bodyProcessDocumentProcessPost.org_id);
    }
    if (bodyProcessDocumentProcessPost.sub_org_id !== undefined) {
      formData.append(`sub_org_id`, bodyProcessDocumentProcessPost.sub_org_id);
    }
    if (bodyProcessDocumentProcessPost.priority !== undefined) {
      formData.append(
        `priority`,
        bodyProcessDocumentProcessPost.priority.toString(),
      );
    }
    if (bodyProcessDocumentProcessPost.metadata !== undefined) {
      formData.append(`metadata`, bodyProcessDocumentProcessPost.metadata);
    }
    if (bodyProcessDocumentProcessPost.doc_type !== undefined) {
      formData.append(`doc_type`, bodyProcessDocumentProcessPost.doc_type);
    }
    formData.append(`file`, bodyProcessDocumentProcessPost.file);

    return customAxiosInstance<unknown>({
      url: `/document/process`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      params,
    });
  };
  /**
   * @summary Process Base64
   */
  const processBase64DocumentProcessBase64Post = (
    bodyProcessBase64DocumentProcessBase64Post: BodyProcessBase64DocumentProcessBase64Post,
    params?: ProcessBase64DocumentProcessBase64PostParams,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (bodyProcessBase64DocumentProcessBase64Post.source !== undefined) {
      formUrlEncoded.append(
        `source`,
        bodyProcessBase64DocumentProcessBase64Post.source,
      );
    }
    formUrlEncoded.append(
      `org_id`,
      bodyProcessBase64DocumentProcessBase64Post.org_id,
    );
    if (bodyProcessBase64DocumentProcessBase64Post.sub_org_id !== undefined) {
      formUrlEncoded.append(
        `sub_org_id`,
        bodyProcessBase64DocumentProcessBase64Post.sub_org_id,
      );
    }
    if (bodyProcessBase64DocumentProcessBase64Post.priority !== undefined) {
      formUrlEncoded.append(
        `priority`,
        bodyProcessBase64DocumentProcessBase64Post.priority.toString(),
      );
    }
    if (
      bodyProcessBase64DocumentProcessBase64Post.metadata !== undefined &&
      bodyProcessBase64DocumentProcessBase64Post.metadata !== null
    ) {
      formUrlEncoded.append(
        `metadata`,
        bodyProcessBase64DocumentProcessBase64Post.metadata,
      );
    }
    if (bodyProcessBase64DocumentProcessBase64Post.doc_type !== undefined) {
      formUrlEncoded.append(
        `doc_type`,
        bodyProcessBase64DocumentProcessBase64Post.doc_type,
      );
    }
    if (bodyProcessBase64DocumentProcessBase64Post.file_name !== undefined) {
      formUrlEncoded.append(
        `file_name`,
        bodyProcessBase64DocumentProcessBase64Post.file_name,
      );
    }
    formUrlEncoded.append(
      `file_contents`,
      bodyProcessBase64DocumentProcessBase64Post.file_contents,
    );

    return customAxiosInstance<unknown>({
      url: `/document/process/base64`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
      params,
    });
  };
  /**
   * @summary Notify Requisitioner
   */
  const notifyRequisitionerDocumentNotifyRequisitionerPost = (
    bodyNotifyRequisitionerDocumentNotifyRequisitionerPost: BodyNotifyRequisitionerDocumentNotifyRequisitionerPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `data`,
      bodyNotifyRequisitionerDocumentNotifyRequisitionerPost.data,
    );

    return customAxiosInstance<unknown>({
      url: `/document/notify/requisitioner`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Update
   */
  const updateDocumentUpdateDocIdPost = (
    docId: string,
    bodyUpdateDocumentUpdateDocIdPost: BodyUpdateDocumentUpdateDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(`org_id`, bodyUpdateDocumentUpdateDocIdPost.org_id);
    formUrlEncoded.append(`data`, bodyUpdateDocumentUpdateDocIdPost.data);
    if (bodyUpdateDocumentUpdateDocIdPost.triggered_by_docflow !== undefined) {
      formUrlEncoded.append(
        `triggered_by_docflow`,
        bodyUpdateDocumentUpdateDocIdPost.triggered_by_docflow.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/update/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Save And Validate
   */
  const saveAndValidateDocumentSaveAndValidateDocIdPost = (
    docId: string,
    bodySaveAndValidateDocumentSaveAndValidateDocIdPost: BodySaveAndValidateDocumentSaveAndValidateDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodySaveAndValidateDocumentSaveAndValidateDocIdPost.org_id,
    );
    formUrlEncoded.append(
      `data`,
      bodySaveAndValidateDocumentSaveAndValidateDocIdPost.data,
    );
    if (
      bodySaveAndValidateDocumentSaveAndValidateDocIdPost.triggered_by_docflow !==
      undefined
    ) {
      formUrlEncoded.append(
        `triggered_by_docflow`,
        bodySaveAndValidateDocumentSaveAndValidateDocIdPost.triggered_by_docflow.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/save_and_validate/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Validate And Export
   */
  const validateAndExportDocumentValidateAndExportDocIdPost = (
    docId: string,
    bodyValidateAndExportDocumentValidateAndExportDocIdPost: BodyValidateAndExportDocumentValidateAndExportDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyValidateAndExportDocumentValidateAndExportDocIdPost.org_id,
    );
    formUrlEncoded.append(
      `data`,
      bodyValidateAndExportDocumentValidateAndExportDocIdPost.data,
    );
    if (
      bodyValidateAndExportDocumentValidateAndExportDocIdPost.triggered_by_docflow !==
      undefined
    ) {
      formUrlEncoded.append(
        `triggered_by_docflow`,
        bodyValidateAndExportDocumentValidateAndExportDocIdPost.triggered_by_docflow.toString(),
      );
    }
    if (
      bodyValidateAndExportDocumentValidateAndExportDocIdPost.ignore_field_validation_errors !==
      undefined
    ) {
      formUrlEncoded.append(
        `ignore_field_validation_errors`,
        bodyValidateAndExportDocumentValidateAndExportDocIdPost.ignore_field_validation_errors.toString(),
      );
    }
    if (
      bodyValidateAndExportDocumentValidateAndExportDocIdPost.validate_po_match !==
      undefined
    ) {
      formUrlEncoded.append(
        `validate_po_match`,
        bodyValidateAndExportDocumentValidateAndExportDocIdPost.validate_po_match.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/validate_and_export/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Rebuild Accounting Models
   */
  const rebuildAccountingModelsDocumentAccountingRebuildPost = (
    params?: RebuildAccountingModelsDocumentAccountingRebuildPostParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/accounting/rebuild`,
      method: 'POST',
      params,
    });
  };
  /**
   * @summary Documents List
   */
  const documentsListDocumentGet = (
    params?: DocumentsListDocumentGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Get Multiple Documents Status
   */
  const getMultipleDocumentsStatusDocumentStatusesGet = (
    params: GetMultipleDocumentsStatusDocumentStatusesGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/statuses`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Documents Status
   */
  const documentsStatusDocumentStatusByIdDocIdGet = (
    docId: string,
    params: DocumentsStatusDocumentStatusByIdDocIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/status/by-id/${docId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Set Documents Status
   */
  const setDocumentsStatusDocumentSetStatusDocIdPost = (
    docId: string,
    bodySetDocumentsStatusDocumentSetStatusDocIdPost: BodySetDocumentsStatusDocumentSetStatusDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (bodySetDocumentsStatusDocumentSetStatusDocIdPost.org_id !== undefined) {
      formUrlEncoded.append(
        `org_id`,
        bodySetDocumentsStatusDocumentSetStatusDocIdPost.org_id,
      );
    }
    formUrlEncoded.append(
      `status`,
      bodySetDocumentsStatusDocumentSetStatusDocIdPost.status,
    );
    if (
      bodySetDocumentsStatusDocumentSetStatusDocIdPost.trigger_docflow !==
      undefined
    ) {
      formUrlEncoded.append(
        `trigger_docflow`,
        bodySetDocumentsStatusDocumentSetStatusDocIdPost.trigger_docflow.toString(),
      );
    }
    if (
      bodySetDocumentsStatusDocumentSetStatusDocIdPost.triggered_by_docflow !==
      undefined
    ) {
      formUrlEncoded.append(
        `triggered_by_docflow`,
        bodySetDocumentsStatusDocumentSetStatusDocIdPost.triggered_by_docflow.toString(),
      );
    }
    if (
      bodySetDocumentsStatusDocumentSetStatusDocIdPost.workflow_name !==
      undefined
    ) {
      formUrlEncoded.append(
        `workflow_name`,
        bodySetDocumentsStatusDocumentSetStatusDocIdPost.workflow_name,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/set_status/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Set Status To Validation
   */
  const setStatusToValidationDocumentSetStatusToReadyForValidationDocIdGet = (
    docId: string,
    params: SetStatusToValidationDocumentSetStatusToReadyForValidationDocIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/set_status_to_ready_for_validation/${docId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Set Field Values
   */
  const setFieldValuesDocumentSetFieldsDocIdPost = (
    docId: string,
    bodySetFieldValuesDocumentSetFieldsDocIdPost: BodySetFieldValuesDocumentSetFieldsDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (bodySetFieldValuesDocumentSetFieldsDocIdPost.org_id !== undefined) {
      formUrlEncoded.append(
        `org_id`,
        bodySetFieldValuesDocumentSetFieldsDocIdPost.org_id,
      );
    }
    formUrlEncoded.append(
      `fields`,
      bodySetFieldValuesDocumentSetFieldsDocIdPost.fields,
    );
    if (
      bodySetFieldValuesDocumentSetFieldsDocIdPost.triggered_by_docflow !==
      undefined
    ) {
      formUrlEncoded.append(
        `triggered_by_docflow`,
        bodySetFieldValuesDocumentSetFieldsDocIdPost.triggered_by_docflow.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/set_fields/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
 * Get dashboard documents with pagination support.

Endpoint: GET /document/dashboard

Query Parameters:
- limit: Number of documents per page (default: 50, max: 1000)
- skip: Number of documents to skip for pagination (default: 0)

Response:
- success: bool
- documents: List of documents
- total: Total document count
- page: Current page number (1-indexed)
 * @summary Get Dashboard
 */
  const getDashboardDocumentDashboardGet = (
    params?: GetDashboardDocumentDashboardGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/dashboard`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Dashboard
   */
  const dashboardDocumentDashboardsGet = (
    params?: DashboardDocumentDashboardsGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/dashboards`,
      method: 'GET',
      params,
    });
  };
  /**
 * Pre-warm dashboard caches for the current user's organisation.

Call this right after login (before the user navigates to the
dashboard) so the first real dashboard query doesn't pay the
cold-cache cost. Typical cold call is ~1.5–2s due to
org-preferences + column-config + overview-stats aggregation
being populated from Postgres into Redis on first hit. Warming
those caches up-front makes the first user-facing search land
on the fast path (~70–150 ms).

Idempotent: safe to call on every login. If caches are already
warm the internal `@redis_cache.redis_cache` decorator returns
immediately (<20 ms). Fire-and-forget from the client side — the
response body is diagnostic only.
 * @summary Warmup Dashboard Caches
 */
  const warmupDashboardCachesDocumentWarmupPost = () => {
    return customAxiosInstance<unknown>({
      url: `/document/warmup`,
      method: 'POST',
    });
  };
  /**
   * @summary Next Document
   */
  const nextDocumentDocumentNextGet = (
    params: NextDocumentDocumentNextGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/next`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Find Duplicates
   */
  const findDuplicatesDocumentDuplicatesGet = (
    params: FindDuplicatesDocumentDuplicatesGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/duplicates`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Auto Accounting Dashboard
   */
  const autoAccountingDashboardDocumentAccountingDashboardPost = (
    bodyAutoAccountingDashboardDocumentAccountingDashboardPost: BodyAutoAccountingDashboardDocumentAccountingDashboardPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (
      bodyAutoAccountingDashboardDocumentAccountingDashboardPost.keyword !==
      undefined
    ) {
      formUrlEncoded.append(
        `keyword`,
        bodyAutoAccountingDashboardDocumentAccountingDashboardPost.keyword,
      );
    }
    formUrlEncoded.append(
      `org_id`,
      bodyAutoAccountingDashboardDocumentAccountingDashboardPost.org_id,
    );
    if (
      bodyAutoAccountingDashboardDocumentAccountingDashboardPost.sub_org_id !==
      undefined
    ) {
      formUrlEncoded.append(
        `sub_org_id`,
        bodyAutoAccountingDashboardDocumentAccountingDashboardPost.sub_org_id,
      );
    }
    if (
      bodyAutoAccountingDashboardDocumentAccountingDashboardPost.filters !==
      undefined
    ) {
      formUrlEncoded.append(
        `filters`,
        bodyAutoAccountingDashboardDocumentAccountingDashboardPost.filters,
      );
    }
    if (
      bodyAutoAccountingDashboardDocumentAccountingDashboardPost.order_by !==
      undefined
    ) {
      formUrlEncoded.append(
        `order_by`,
        bodyAutoAccountingDashboardDocumentAccountingDashboardPost.order_by,
      );
    }
    if (
      bodyAutoAccountingDashboardDocumentAccountingDashboardPost.skip !==
      undefined
    ) {
      formUrlEncoded.append(
        `skip`,
        bodyAutoAccountingDashboardDocumentAccountingDashboardPost.skip.toString(),
      );
    }
    if (
      bodyAutoAccountingDashboardDocumentAccountingDashboardPost.limit !==
      undefined
    ) {
      formUrlEncoded.append(
        `limit`,
        bodyAutoAccountingDashboardDocumentAccountingDashboardPost.limit.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/accounting/dashboard`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Extraction Result
   */
  const extractionResultDocumentExtractionResultPost = (
    bodyExtractionResultDocumentExtractionResultPost: BodyExtractionResultDocumentExtractionResultPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyExtractionResultDocumentExtractionResultPost.doc_id,
    );
    formUrlEncoded.append(
      `org_id`,
      bodyExtractionResultDocumentExtractionResultPost.org_id,
    );
    if (
      bodyExtractionResultDocumentExtractionResultPost.no_cache !== undefined
    ) {
      formUrlEncoded.append(
        `no_cache`,
        bodyExtractionResultDocumentExtractionResultPost.no_cache.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/extraction/result`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Extraction Result V2
   */
  const extractionResultV2DocumentExtractionResultV2Post = (
    bodyExtractionResultV2DocumentExtractionResultV2Post: BodyExtractionResultV2DocumentExtractionResultV2Post,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyExtractionResultV2DocumentExtractionResultV2Post.doc_id,
    );
    formUrlEncoded.append(
      `org_id`,
      bodyExtractionResultV2DocumentExtractionResultV2Post.org_id,
    );
    if (
      bodyExtractionResultV2DocumentExtractionResultV2Post.no_cache !==
      undefined
    ) {
      formUrlEncoded.append(
        `no_cache`,
        bodyExtractionResultV2DocumentExtractionResultV2Post.no_cache.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/extraction/result/v2`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Clear Extracted Data Cache
   */
  const clearExtractedDataCacheDocumentExtractionCacheClearPost = (
    bodyClearExtractedDataCacheDocumentExtractionCacheClearPost: BodyClearExtractedDataCacheDocumentExtractionCacheClearPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyClearExtractedDataCacheDocumentExtractionCacheClearPost.doc_id,
    );
    formUrlEncoded.append(
      `org_id`,
      bodyClearExtractedDataCacheDocumentExtractionCacheClearPost.org_id,
    );

    return customAxiosInstance<unknown>({
      url: `/document/extraction/cache/clear`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Items From Dictionary Sync
   */
  const getItemsFromDictionarySyncDocumentGetItemsFromDictionaryItemGet = (
    item: string,
    params?: GetItemsFromDictionarySyncDocumentGetItemsFromDictionaryItemGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/get_items_from_dictionary/${item}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Restart
   */
  const restartDocumentRestartDocIdGet = (
    docId: string,
    params?: RestartDocumentRestartDocIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/restart/${docId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Restart Documents
   */
  const restartDocumentsDocumentRestartPost = (
    bodyRestartDocumentsDocumentRestartPost: BodyRestartDocumentsDocumentRestartPost,
    params?: RestartDocumentsDocumentRestartPostParams,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    bodyRestartDocumentsDocumentRestartPost.doc_ids.forEach((value) =>
      formUrlEncoded.append(`doc_ids`, value),
    );

    return customAxiosInstance<unknown>({
      url: `/document/restart`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
      params,
    });
  };
  /**
   * @summary Approve Or Reject
   */
  const approveOrRejectDocumentApproveOrRejectDocIdPost = (
    docId: string,
    bodyApproveOrRejectDocumentApproveOrRejectDocIdPost: BodyApproveOrRejectDocumentApproveOrRejectDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyApproveOrRejectDocumentApproveOrRejectDocIdPost.org_id,
    );
    if (
      bodyApproveOrRejectDocumentApproveOrRejectDocIdPost.triggered_by_docflow !==
      undefined
    ) {
      formUrlEncoded.append(
        `triggered_by_docflow`,
        bodyApproveOrRejectDocumentApproveOrRejectDocIdPost.triggered_by_docflow.toString(),
      );
    }
    if (
      bodyApproveOrRejectDocumentApproveOrRejectDocIdPost.request_type !==
      undefined
    ) {
      formUrlEncoded.append(
        `request_type`,
        bodyApproveOrRejectDocumentApproveOrRejectDocIdPost.request_type,
      );
    }
    if (
      bodyApproveOrRejectDocumentApproveOrRejectDocIdPost.notes !== undefined
    ) {
      formUrlEncoded.append(
        `notes`,
        bodyApproveOrRejectDocumentApproveOrRejectDocIdPost.notes,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/approve_or_reject/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Update Document Log
   */
  const updateDocumentLogDocumentUpdateDocumentLogDocIdPost = (
    docId: string,
    bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost: BodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost.org_id,
    );
    formUrlEncoded.append(
      `action_type`,
      bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost.action_type,
    );
    formUrlEncoded.append(
      `current_status`,
      bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost.current_status,
    );
    formUrlEncoded.append(
      `previous_status`,
      bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost.previous_status,
    );
    if (
      bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost.action_description !==
      undefined
    ) {
      formUrlEncoded.append(
        `action_description`,
        bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost.action_description,
      );
    }
    if (
      bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost.mentioned_users !==
      undefined
    ) {
      formUrlEncoded.append(
        `mentioned_users`,
        bodyUpdateDocumentLogDocumentUpdateDocumentLogDocIdPost.mentioned_users,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/update_document_log/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Document Log
   */
  const getDocumentLogDocumentGetDocumentLogDocIdPost = (
    docId: string,
    bodyGetDocumentLogDocumentGetDocumentLogDocIdPost: BodyGetDocumentLogDocumentGetDocumentLogDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (
      bodyGetDocumentLogDocumentGetDocumentLogDocIdPost.action_type !==
      undefined
    ) {
      formUrlEncoded.append(
        `action_type`,
        bodyGetDocumentLogDocumentGetDocumentLogDocIdPost.action_type,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/get_document_log/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Restart With New Classification
   */
  const restartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost =
    (
      docId: string,
      bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost: BodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost,
      params?: RestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPostParams,
    ) => {
      const formUrlEncoded = new URLSearchParams();
      formUrlEncoded.append(
        `org_id`,
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.org_id,
      );
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_type !==
        undefined
      ) {
        formUrlEncoded.append(
          `doc_type`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_type,
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.sub_doc_type !==
        undefined
      ) {
        formUrlEncoded.append(
          `sub_doc_type`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.sub_doc_type,
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_language !==
        undefined
      ) {
        formUrlEncoded.append(
          `doc_language`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_language,
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_origin !==
        undefined
      ) {
        formUrlEncoded.append(
          `doc_origin`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_origin,
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_locale !==
        undefined
      ) {
        formUrlEncoded.append(
          `doc_locale`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_locale,
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_classification_label !==
        undefined
      ) {
        formUrlEncoded.append(
          `doc_classification_label`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_classification_label,
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_start_page !==
        undefined
      ) {
        formUrlEncoded.append(
          `doc_start_page`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.doc_start_page.toString(),
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.force_ocr !==
        undefined
      ) {
        formUrlEncoded.append(
          `force_ocr`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.force_ocr.toString(),
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.improve_quality !==
        undefined
      ) {
        formUrlEncoded.append(
          `improve_quality`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.improve_quality.toString(),
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.pages_to_process !==
        undefined
      ) {
        formUrlEncoded.append(
          `pages_to_process`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.pages_to_process,
        );
      }
      if (
        bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.use_pdf_processor !==
        undefined
      ) {
        formUrlEncoded.append(
          `use_pdf_processor`,
          bodyRestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost.use_pdf_processor.toString(),
        );
      }

      return customAxiosInstance<unknown>({
        url: `/document/restart_with_new_classification/${docId}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
        params,
      });
    };
  /**
   * @summary Restart Export
   */
  const restartExportDocumentRestartExportDocIdGet = (
    docId: string,
    params?: RestartExportDocumentRestartExportDocIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/restart_export/${docId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Restart Export Documents
   */
  const restartExportDocumentsDocumentRestartExportDocumentsDocIdsGet = (
    docIds: string,
    params?: RestartExportDocumentsDocumentRestartExportDocumentsDocIdsGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/restart_export_documents/${docIds}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Restart Export With Status
   */
  const restartExportWithStatusDocumentRestartExportWithStatusOrgIdGet = (
    orgId: string,
    params: RestartExportWithStatusDocumentRestartExportWithStatusOrgIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/restart_export_with_status/${orgId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Get Doc Status Info
   */
  const getDocStatusInfoDocumentGetDocStatusInfoDocIdGet = (
    docId: string,
    params: GetDocStatusInfoDocumentGetDocStatusInfoDocIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/get_doc_status_info/${docId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Get Document
   */
  const getDocumentDocumentByIdDocIdGet = (
    docId: string,
    params: GetDocumentDocumentByIdDocIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/by-id/${docId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Delete Document
   */
  const deleteDocumentDocumentDeleteDocIdDelete = (
    docId: string,
    params: DeleteDocumentDocumentDeleteDocIdDeleteParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/delete/${docId}`,
      method: 'DELETE',
      params,
    });
  };
  /**
   * @summary Delete Documents
   */
  const deleteDocumentsDocumentDeleteDocumentsDelete = (
    bodyDeleteDocumentsDocumentDeleteDocumentsDelete: BodyDeleteDocumentsDocumentDeleteDocumentsDelete,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    bodyDeleteDocumentsDocumentDeleteDocumentsDelete.doc_ids.forEach((value) =>
      formUrlEncoded.append(`doc_ids`, value),
    );
    formUrlEncoded.append(
      `org_id`,
      bodyDeleteDocumentsDocumentDeleteDocumentsDelete.org_id,
    );

    return customAxiosInstance<unknown>({
      url: `/document/delete_documents`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Assign
   */
  const assignDocumentAssignDocIdPost = (
    docId: string,
    bodyAssignDocumentAssignDocIdPost: BodyAssignDocumentAssignDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(`org_id`, bodyAssignDocumentAssignDocIdPost.org_id);
    if (bodyAssignDocumentAssignDocIdPost.assign_to !== undefined) {
      formUrlEncoded.append(
        `assign_to`,
        bodyAssignDocumentAssignDocIdPost.assign_to,
      );
    }
    if (bodyAssignDocumentAssignDocIdPost.assignment_type !== undefined) {
      formUrlEncoded.append(
        `assignment_type`,
        bodyAssignDocumentAssignDocIdPost.assignment_type,
      );
    }
    if (bodyAssignDocumentAssignDocIdPost.triggered_by_docflow !== undefined) {
      formUrlEncoded.append(
        `triggered_by_docflow`,
        bodyAssignDocumentAssignDocIdPost.triggered_by_docflow.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/assign/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Assign Documents
   */
  const assignDocumentsDocumentAssignPost = (
    bodyAssignDocumentsDocumentAssignPost: BodyAssignDocumentsDocumentAssignPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyAssignDocumentsDocumentAssignPost.org_id,
    );
    if (bodyAssignDocumentsDocumentAssignPost.assign_to_sub_org !== undefined) {
      formUrlEncoded.append(
        `assign_to_sub_org`,
        bodyAssignDocumentsDocumentAssignPost.assign_to_sub_org,
      );
    }
    if (bodyAssignDocumentsDocumentAssignPost.assign_to_user !== undefined) {
      formUrlEncoded.append(
        `assign_to_user`,
        bodyAssignDocumentsDocumentAssignPost.assign_to_user,
      );
    }
    if (bodyAssignDocumentsDocumentAssignPost.assign_to_group !== undefined) {
      formUrlEncoded.append(
        `assign_to_group`,
        bodyAssignDocumentsDocumentAssignPost.assign_to_group,
      );
    }
    bodyAssignDocumentsDocumentAssignPost.doc_ids.forEach((value) =>
      formUrlEncoded.append(`doc_ids`, value),
    );

    return customAxiosInstance<unknown>({
      url: `/document/assign`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Assign With Email
   */
  const assignWithEmailDocumentAssignWithEmailDocIdPost = (
    docId: string,
    bodyAssignWithEmailDocumentAssignWithEmailDocIdPost: BodyAssignWithEmailDocumentAssignWithEmailDocIdPost,
    params: AssignWithEmailDocumentAssignWithEmailDocIdPostParams,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `assign_to`,
      bodyAssignWithEmailDocumentAssignWithEmailDocIdPost.assign_to,
    );

    return customAxiosInstance<unknown>({
      url: `/document/assign_with_email/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
      params,
    });
  };
  /**
   * @summary Get Next Document
   */
  const getNextDocumentDocumentGetNextDocumentDocIdGet = (
    docId: string,
    params: GetNextDocumentDocumentGetNextDocumentDocIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/get_next_document/${docId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Get Ocr Data
   */
  const getOcrDataDocumentGetOcrDataDocIdPost = (
    docId: string,
    bodyGetOcrDataDocumentGetOcrDataDocIdPost: BodyGetOcrDataDocumentGetOcrDataDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyGetOcrDataDocumentGetOcrDataDocIdPost.org_id,
    );
    formUrlEncoded.append(
      `page_number`,
      bodyGetOcrDataDocumentGetOcrDataDocIdPost.page_number.toString(),
    );
    if (
      bodyGetOcrDataDocumentGetOcrDataDocIdPost.include_font_size !== undefined
    ) {
      formUrlEncoded.append(
        `include_font_size`,
        bodyGetOcrDataDocumentGetOcrDataDocIdPost.include_font_size.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/get_ocr_data/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Document Content
   */
  const getDocumentContentDocumentGetDocumentContentDocIdPost = (
    docId: string,
    bodyGetDocumentContentDocumentGetDocumentContentDocIdPost: BodyGetDocumentContentDocumentGetDocumentContentDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyGetDocumentContentDocumentGetDocumentContentDocIdPost.org_id,
    );

    return customAxiosInstance<unknown>({
      url: `/document/get_document_content/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Split Document
   */
  const splitDocumentDocumentSplitPost = (
    bodySplitDocumentDocumentSplitPost: BodySplitDocumentDocumentSplitPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(`doc_id`, bodySplitDocumentDocumentSplitPost.doc_id);
    formUrlEncoded.append(`org_id`, bodySplitDocumentDocumentSplitPost.org_id);
    if (bodySplitDocumentDocumentSplitPost.separators !== undefined) {
      formUrlEncoded.append(
        `separators`,
        bodySplitDocumentDocumentSplitPost.separators,
      );
    }
    if (bodySplitDocumentDocumentSplitPost.sorted_indexes !== undefined) {
      formUrlEncoded.append(
        `sorted_indexes`,
        bodySplitDocumentDocumentSplitPost.sorted_indexes,
      );
    }
    if (bodySplitDocumentDocumentSplitPost.deleted_indexes !== undefined) {
      formUrlEncoded.append(
        `deleted_indexes`,
        bodySplitDocumentDocumentSplitPost.deleted_indexes,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/split`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Merge Documents
   */
  const mergeDocumentsDocumentMergePost = (
    bodyMergeDocumentsDocumentMergePost: BodyMergeDocumentsDocumentMergePost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_ids`,
      bodyMergeDocumentsDocumentMergePost.doc_ids,
    );
    formUrlEncoded.append(`org_id`, bodyMergeDocumentsDocumentMergePost.org_id);

    return customAxiosInstance<unknown>({
      url: `/document/merge`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Append Files To Document
   */
  const appendFilesToDocumentDocumentAppendPost = (
    bodyAppendFilesToDocumentDocumentAppendPost: BodyAppendFilesToDocumentDocumentAppendPost,
  ) => {
    const formData = new FormData();
    formData.append(
      `doc_id`,
      bodyAppendFilesToDocumentDocumentAppendPost.doc_id,
    );
    formData.append(
      `org_id`,
      bodyAppendFilesToDocumentDocumentAppendPost.org_id,
    );
    bodyAppendFilesToDocumentDocumentAppendPost.files.forEach((value) =>
      formData.append(`files`, value),
    );

    return customAxiosInstance<unknown>({
      url: `/document/append`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };
  /**
   * @summary Generate Thumbnails
   */
  const generateThumbnailsDocumentThumbnailsPost = (
    bodyGenerateThumbnailsDocumentThumbnailsPost: BodyGenerateThumbnailsDocumentThumbnailsPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyGenerateThumbnailsDocumentThumbnailsPost.doc_id,
    );
    formUrlEncoded.append(
      `org_id`,
      bodyGenerateThumbnailsDocumentThumbnailsPost.org_id,
    );

    return customAxiosInstance<unknown>({
      url: `/document/thumbnails`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Doc Status Xml
   */
  const getDocStatusXmlDocumentStatusXmlPost = (
    bodyGetDocStatusXmlDocumentStatusXmlPost: BodyGetDocStatusXmlDocumentStatusXmlPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyGetDocStatusXmlDocumentStatusXmlPost.doc_id,
    );
    if (bodyGetDocStatusXmlDocumentStatusXmlPost.org_id !== undefined) {
      formUrlEncoded.append(
        `org_id`,
        bodyGetDocStatusXmlDocumentStatusXmlPost.org_id,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/status/xml`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Doc Status Xml List
   */
  const getDocStatusXmlListDocumentStatusXmlListPost = (
    bodyGetDocStatusXmlListDocumentStatusXmlListPost: BodyGetDocStatusXmlListDocumentStatusXmlListPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (bodyGetDocStatusXmlListDocumentStatusXmlListPost.org_id !== undefined) {
      formUrlEncoded.append(
        `org_id`,
        bodyGetDocStatusXmlListDocumentStatusXmlListPost.org_id,
      );
    }
    if (bodyGetDocStatusXmlListDocumentStatusXmlListPost.days !== undefined) {
      formUrlEncoded.append(
        `days`,
        bodyGetDocStatusXmlListDocumentStatusXmlListPost.days.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/status/xml/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Apply Script
   */
  const applyScriptDocumentScriptApplyPost = (
    bodyApplyScriptDocumentScriptApplyPost: BodyApplyScriptDocumentScriptApplyPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyApplyScriptDocumentScriptApplyPost.org_id,
    );
    formUrlEncoded.append(
      `doc_json`,
      bodyApplyScriptDocumentScriptApplyPost.doc_json,
    );
    if (bodyApplyScriptDocumentScriptApplyPost.trigger !== undefined) {
      formUrlEncoded.append(
        `trigger`,
        bodyApplyScriptDocumentScriptApplyPost.trigger,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/script/apply`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Apply Script On Document
   */
  const applyScriptOnDocumentDocumentScriptApplyToDocumentPost = (
    bodyApplyScriptOnDocumentDocumentScriptApplyToDocumentPost: BodyApplyScriptOnDocumentDocumentScriptApplyToDocumentPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyApplyScriptOnDocumentDocumentScriptApplyToDocumentPost.doc_id,
    );
    formUrlEncoded.append(
      `org_id`,
      bodyApplyScriptOnDocumentDocumentScriptApplyToDocumentPost.org_id,
    );
    formUrlEncoded.append(
      `trigger`,
      bodyApplyScriptOnDocumentDocumentScriptApplyToDocumentPost.trigger,
    );

    return customAxiosInstance<unknown>({
      url: `/document/script/apply-to-document`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Document Type Filter Keys
   */
  const getDocumentTypeFilterKeysDocumentFiltersDocumentTypesPost = (
    bodyGetDocumentTypeFilterKeysDocumentFiltersDocumentTypesPost: BodyGetDocumentTypeFilterKeysDocumentFiltersDocumentTypesPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `org_id`,
      bodyGetDocumentTypeFilterKeysDocumentFiltersDocumentTypesPost.org_id,
    );

    return customAxiosInstance<unknown>({
      url: `/document/filters/document-types`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Get Documents By Batch Id
   */
  const getDocumentsByBatchIdDocumentGetDocumentsByBatchIdBatchIdGet = (
    batchId: string,
    params: GetDocumentsByBatchIdDocumentGetDocumentsByBatchIdBatchIdGetParams,
  ) => {
    return customAxiosInstance<unknown>({
      url: `/document/get_documents_by_batch_id/${batchId}`,
      method: 'GET',
      params,
    });
  };
  /**
   * @summary Get Related Documents
   */
  const getRelatedDocumentsDocumentRelatedPost = (
    bodyGetRelatedDocumentsDocumentRelatedPost: BodyGetRelatedDocumentsDocumentRelatedPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `doc_id`,
      bodyGetRelatedDocumentsDocumentRelatedPost.doc_id,
    );
    if (
      bodyGetRelatedDocumentsDocumentRelatedPost.org_id !== undefined &&
      bodyGetRelatedDocumentsDocumentRelatedPost.org_id !== null
    ) {
      formUrlEncoded.append(
        `org_id`,
        bodyGetRelatedDocumentsDocumentRelatedPost.org_id,
      );
    }
    if (bodyGetRelatedDocumentsDocumentRelatedPost.attributes !== undefined) {
      bodyGetRelatedDocumentsDocumentRelatedPost.attributes.forEach((value) =>
        formUrlEncoded.append(`attributes`, value),
      );
    }
    if (
      bodyGetRelatedDocumentsDocumentRelatedPost.include_documents_same_type !==
      undefined
    ) {
      formUrlEncoded.append(
        `include_documents_same_type`,
        bodyGetRelatedDocumentsDocumentRelatedPost.include_documents_same_type.toString(),
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/related`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Export Dashboard Data
   */
  const exportDashboardDataDocumentExportsDashboardPost = (
    bodyExportDashboardDataDocumentExportsDashboardPost: BodyExportDashboardDataDocumentExportsDashboardPost,
    params?: ExportDashboardDataDocumentExportsDashboardPostParams,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `type`,
      bodyExportDashboardDataDocumentExportsDashboardPost.type,
    );

    return customAxiosInstance<unknown>({
      url: `/document/exports/dashboard`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
      params,
    });
  };
  /**
   * @summary Update Pending Workflow
   */
  const updatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost = (
    docId: string,
    bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost: BodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    if (
      bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.org_id !==
        undefined &&
      bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.org_id !==
        null
    ) {
      formUrlEncoded.append(
        `org_id`,
        bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.org_id,
      );
    }
    if (
      bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.pending_workflow_execution !==
      undefined
    ) {
      formUrlEncoded.append(
        `pending_workflow_execution`,
        bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.pending_workflow_execution.toString(),
      );
    }
    if (
      bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.triggered_by_docflow !==
      undefined
    ) {
      formUrlEncoded.append(
        `triggered_by_docflow`,
        bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.triggered_by_docflow.toString(),
      );
    }
    if (
      bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.workflow_execution_timestamp !==
        undefined &&
      bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.workflow_execution_timestamp !==
        null
    ) {
      formUrlEncoded.append(
        `workflow_execution_timestamp`,
        bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.workflow_execution_timestamp,
      );
    }
    if (
      bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.celery_task_id !==
        undefined &&
      bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.celery_task_id !==
        null
    ) {
      formUrlEncoded.append(
        `celery_task_id`,
        bodyUpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost.celery_task_id,
      );
    }

    return customAxiosInstance<unknown>({
      url: `/document/update_pending_workflow/${docId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
    });
  };
  /**
   * @summary Create Dashboard Export Request
   */
  const createDashboardExportRequestDocumentExportsRequestsPost = (
    bodyCreateDashboardExportRequestDocumentExportsRequestsPost: BodyCreateDashboardExportRequestDocumentExportsRequestsPost,
    params?: CreateDashboardExportRequestDocumentExportsRequestsPostParams,
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(
      `type`,
      bodyCreateDashboardExportRequestDocumentExportsRequestsPost.type,
    );

    return customAxiosInstance<unknown>({
      url: `/document/exports/requests`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formUrlEncoded,
      params,
    });
  };
  return {
    getAnnotationsDocumentAnnotationGetAnnotationsPost,
    annotateDocumentDocumentAnnotationAnnotateDocumentPost,
    editAnnotationDocumentAnnotationEditAnnotationPut,
    stampOnDocumentDocumentAnnotationStampDocumentPost,
    editDocumentStampDocumentAnnotationEditDocumentStampPut,
    removeAnnotationDocumentAnnotationRemoveAnnotationDelete,
    getEnhancedDocumentErrorsDocumentErrorAnalyticsGetErrorsDocIdGet,
    retryDocumentFromStepDocumentErrorAnalyticsRetryFromStepDocIdPost,
    getProactiveAlertsDocumentErrorAnalyticsProactiveAlertsGet,
    getErrorPatternsDocumentErrorAnalyticsAnalyticsErrorPatternsGet,
    getSearchFieldsCatalogDocumentSearchFieldsGet,
    getDashboardExportLogsDocumentExportsLogsGet,
    classifyDocumentDocumentClassifyPost,
    processDocumentsDocumentProcessDocumentsPost,
    processDocumentImportPost,
    processDocumentProcessPost,
    processBase64DocumentProcessBase64Post,
    notifyRequisitionerDocumentNotifyRequisitionerPost,
    updateDocumentUpdateDocIdPost,
    saveAndValidateDocumentSaveAndValidateDocIdPost,
    validateAndExportDocumentValidateAndExportDocIdPost,
    rebuildAccountingModelsDocumentAccountingRebuildPost,
    documentsListDocumentGet,
    getMultipleDocumentsStatusDocumentStatusesGet,
    documentsStatusDocumentStatusByIdDocIdGet,
    setDocumentsStatusDocumentSetStatusDocIdPost,
    setStatusToValidationDocumentSetStatusToReadyForValidationDocIdGet,
    setFieldValuesDocumentSetFieldsDocIdPost,
    getDashboardDocumentDashboardGet,
    dashboardDocumentDashboardsGet,
    warmupDashboardCachesDocumentWarmupPost,
    nextDocumentDocumentNextGet,
    findDuplicatesDocumentDuplicatesGet,
    autoAccountingDashboardDocumentAccountingDashboardPost,
    extractionResultDocumentExtractionResultPost,
    extractionResultV2DocumentExtractionResultV2Post,
    clearExtractedDataCacheDocumentExtractionCacheClearPost,
    getItemsFromDictionarySyncDocumentGetItemsFromDictionaryItemGet,
    restartDocumentRestartDocIdGet,
    restartDocumentsDocumentRestartPost,
    approveOrRejectDocumentApproveOrRejectDocIdPost,
    updateDocumentLogDocumentUpdateDocumentLogDocIdPost,
    getDocumentLogDocumentGetDocumentLogDocIdPost,
    restartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost,
    restartExportDocumentRestartExportDocIdGet,
    restartExportDocumentsDocumentRestartExportDocumentsDocIdsGet,
    restartExportWithStatusDocumentRestartExportWithStatusOrgIdGet,
    getDocStatusInfoDocumentGetDocStatusInfoDocIdGet,
    getDocumentDocumentByIdDocIdGet,
    deleteDocumentDocumentDeleteDocIdDelete,
    deleteDocumentsDocumentDeleteDocumentsDelete,
    assignDocumentAssignDocIdPost,
    assignDocumentsDocumentAssignPost,
    assignWithEmailDocumentAssignWithEmailDocIdPost,
    getNextDocumentDocumentGetNextDocumentDocIdGet,
    getOcrDataDocumentGetOcrDataDocIdPost,
    getDocumentContentDocumentGetDocumentContentDocIdPost,
    splitDocumentDocumentSplitPost,
    mergeDocumentsDocumentMergePost,
    appendFilesToDocumentDocumentAppendPost,
    generateThumbnailsDocumentThumbnailsPost,
    getDocStatusXmlDocumentStatusXmlPost,
    getDocStatusXmlListDocumentStatusXmlListPost,
    applyScriptDocumentScriptApplyPost,
    applyScriptOnDocumentDocumentScriptApplyToDocumentPost,
    getDocumentTypeFilterKeysDocumentFiltersDocumentTypesPost,
    getDocumentsByBatchIdDocumentGetDocumentsByBatchIdBatchIdGet,
    getRelatedDocumentsDocumentRelatedPost,
    exportDashboardDataDocumentExportsDashboardPost,
    updatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost,
    createDashboardExportRequestDocumentExportsRequestsPost,
  };
};
export type GetAnnotationsDocumentAnnotationGetAnnotationsPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getAnnotationsDocumentAnnotationGetAnnotationsPost']
      >
    >
  >;
export type AnnotateDocumentDocumentAnnotationAnnotateDocumentPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['annotateDocumentDocumentAnnotationAnnotateDocumentPost']
      >
    >
  >;
export type EditAnnotationDocumentAnnotationEditAnnotationPutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['editAnnotationDocumentAnnotationEditAnnotationPut']
      >
    >
  >;
export type StampOnDocumentDocumentAnnotationStampDocumentPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['stampOnDocumentDocumentAnnotationStampDocumentPost']
      >
    >
  >;
export type EditDocumentStampDocumentAnnotationEditDocumentStampPutResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['editDocumentStampDocumentAnnotationEditDocumentStampPut']
      >
    >
  >;
export type RemoveAnnotationDocumentAnnotationRemoveAnnotationDeleteResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['removeAnnotationDocumentAnnotationRemoveAnnotationDelete']
      >
    >
  >;
export type GetEnhancedDocumentErrorsDocumentErrorAnalyticsGetErrorsDocIdGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getEnhancedDocumentErrorsDocumentErrorAnalyticsGetErrorsDocIdGet']
      >
    >
  >;
export type RetryDocumentFromStepDocumentErrorAnalyticsRetryFromStepDocIdPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['retryDocumentFromStepDocumentErrorAnalyticsRetryFromStepDocIdPost']
      >
    >
  >;
export type GetProactiveAlertsDocumentErrorAnalyticsProactiveAlertsGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getProactiveAlertsDocumentErrorAnalyticsProactiveAlertsGet']
      >
    >
  >;
export type GetErrorPatternsDocumentErrorAnalyticsAnalyticsErrorPatternsGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getErrorPatternsDocumentErrorAnalyticsAnalyticsErrorPatternsGet']
      >
    >
  >;
export type GetSearchFieldsCatalogDocumentSearchFieldsGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['getSearchFieldsCatalogDocumentSearchFieldsGet']
    >
  >
>;
export type GetDashboardExportLogsDocumentExportsLogsGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['getDashboardExportLogsDocumentExportsLogsGet']
    >
  >
>;
export type ClassifyDocumentDocumentClassifyPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['classifyDocumentDocumentClassifyPost']
    >
  >
>;
export type ProcessDocumentsDocumentProcessDocumentsPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['processDocumentsDocumentProcessDocumentsPost']
    >
  >
>;
export type ProcessDocumentImportPostResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['processDocumentImportPost']>
  >
>;
export type ProcessDocumentProcessPostResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['processDocumentProcessPost']>
  >
>;
export type ProcessBase64DocumentProcessBase64PostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['processBase64DocumentProcessBase64Post']
    >
  >
>;
export type NotifyRequisitionerDocumentNotifyRequisitionerPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['notifyRequisitionerDocumentNotifyRequisitionerPost']
      >
    >
  >;
export type UpdateDocumentUpdateDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['updateDocumentUpdateDocIdPost']>
  >
>;
export type SaveAndValidateDocumentSaveAndValidateDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['saveAndValidateDocumentSaveAndValidateDocIdPost']
    >
  >
>;
export type ValidateAndExportDocumentValidateAndExportDocIdPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['validateAndExportDocumentValidateAndExportDocIdPost']
      >
    >
  >;
export type RebuildAccountingModelsDocumentAccountingRebuildPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['rebuildAccountingModelsDocumentAccountingRebuildPost']
      >
    >
  >;
export type DocumentsListDocumentGetResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['documentsListDocumentGet']>
  >
>;
export type GetMultipleDocumentsStatusDocumentStatusesGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['getMultipleDocumentsStatusDocumentStatusesGet']
    >
  >
>;
export type DocumentsStatusDocumentStatusByIdDocIdGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['documentsStatusDocumentStatusByIdDocIdGet']
    >
  >
>;
export type SetDocumentsStatusDocumentSetStatusDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['setDocumentsStatusDocumentSetStatusDocIdPost']
    >
  >
>;
export type SetStatusToValidationDocumentSetStatusToReadyForValidationDocIdGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['setStatusToValidationDocumentSetStatusToReadyForValidationDocIdGet']
      >
    >
  >;
export type SetFieldValuesDocumentSetFieldsDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['setFieldValuesDocumentSetFieldsDocIdPost']
    >
  >
>;
export type GetDashboardDocumentDashboardGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['getDashboardDocumentDashboardGet']
    >
  >
>;
export type DashboardDocumentDashboardsGetResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['dashboardDocumentDashboardsGet']>
  >
>;
export type WarmupDashboardCachesDocumentWarmupPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['warmupDashboardCachesDocumentWarmupPost']
    >
  >
>;
export type NextDocumentDocumentNextGetResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['nextDocumentDocumentNextGet']>
  >
>;
export type FindDuplicatesDocumentDuplicatesGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['findDuplicatesDocumentDuplicatesGet']
    >
  >
>;
export type AutoAccountingDashboardDocumentAccountingDashboardPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['autoAccountingDashboardDocumentAccountingDashboardPost']
      >
    >
  >;
export type ExtractionResultDocumentExtractionResultPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['extractionResultDocumentExtractionResultPost']
    >
  >
>;
export type ExtractionResultV2DocumentExtractionResultV2PostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['extractionResultV2DocumentExtractionResultV2Post']
      >
    >
  >;
export type ClearExtractedDataCacheDocumentExtractionCacheClearPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['clearExtractedDataCacheDocumentExtractionCacheClearPost']
      >
    >
  >;
export type GetItemsFromDictionarySyncDocumentGetItemsFromDictionaryItemGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getItemsFromDictionarySyncDocumentGetItemsFromDictionaryItemGet']
      >
    >
  >;
export type RestartDocumentRestartDocIdGetResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['restartDocumentRestartDocIdGet']>
  >
>;
export type RestartDocumentsDocumentRestartPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['restartDocumentsDocumentRestartPost']
    >
  >
>;
export type ApproveOrRejectDocumentApproveOrRejectDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['approveOrRejectDocumentApproveOrRejectDocIdPost']
    >
  >
>;
export type UpdateDocumentLogDocumentUpdateDocumentLogDocIdPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['updateDocumentLogDocumentUpdateDocumentLogDocIdPost']
      >
    >
  >;
export type GetDocumentLogDocumentGetDocumentLogDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['getDocumentLogDocumentGetDocumentLogDocIdPost']
    >
  >
>;
export type RestartWithNewClassificationDocumentRestartWithNewClassificationDocIdPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['restartWithNewClassificationDocumentRestartWithNewClassificationDocIdPost']
      >
    >
  >;
export type RestartExportDocumentRestartExportDocIdGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['restartExportDocumentRestartExportDocIdGet']
    >
  >
>;
export type RestartExportDocumentsDocumentRestartExportDocumentsDocIdsGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['restartExportDocumentsDocumentRestartExportDocumentsDocIdsGet']
      >
    >
  >;
export type RestartExportWithStatusDocumentRestartExportWithStatusOrgIdGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['restartExportWithStatusDocumentRestartExportWithStatusOrgIdGet']
      >
    >
  >;
export type GetDocStatusInfoDocumentGetDocStatusInfoDocIdGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getDocStatusInfoDocumentGetDocStatusInfoDocIdGet']
      >
    >
  >;
export type GetDocumentDocumentByIdDocIdGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['getDocumentDocumentByIdDocIdGet']
    >
  >
>;
export type DeleteDocumentDocumentDeleteDocIdDeleteResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['deleteDocumentDocumentDeleteDocIdDelete']
    >
  >
>;
export type DeleteDocumentsDocumentDeleteDocumentsDeleteResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['deleteDocumentsDocumentDeleteDocumentsDelete']
    >
  >
>;
export type AssignDocumentAssignDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['assignDocumentAssignDocIdPost']>
  >
>;
export type AssignDocumentsDocumentAssignPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['assignDocumentsDocumentAssignPost']
    >
  >
>;
export type AssignWithEmailDocumentAssignWithEmailDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['assignWithEmailDocumentAssignWithEmailDocIdPost']
    >
  >
>;
export type GetNextDocumentDocumentGetNextDocumentDocIdGetResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['getNextDocumentDocumentGetNextDocumentDocIdGet']
    >
  >
>;
export type GetOcrDataDocumentGetOcrDataDocIdPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['getOcrDataDocumentGetOcrDataDocIdPost']
    >
  >
>;
export type GetDocumentContentDocumentGetDocumentContentDocIdPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getDocumentContentDocumentGetDocumentContentDocIdPost']
      >
    >
  >;
export type SplitDocumentDocumentSplitPostResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getDocument>['splitDocumentDocumentSplitPost']>
  >
>;
export type MergeDocumentsDocumentMergePostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['mergeDocumentsDocumentMergePost']
    >
  >
>;
export type AppendFilesToDocumentDocumentAppendPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['appendFilesToDocumentDocumentAppendPost']
    >
  >
>;
export type GenerateThumbnailsDocumentThumbnailsPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['generateThumbnailsDocumentThumbnailsPost']
    >
  >
>;
export type GetDocStatusXmlDocumentStatusXmlPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['getDocStatusXmlDocumentStatusXmlPost']
    >
  >
>;
export type GetDocStatusXmlListDocumentStatusXmlListPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['getDocStatusXmlListDocumentStatusXmlListPost']
    >
  >
>;
export type ApplyScriptDocumentScriptApplyPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['applyScriptDocumentScriptApplyPost']
    >
  >
>;
export type ApplyScriptOnDocumentDocumentScriptApplyToDocumentPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['applyScriptOnDocumentDocumentScriptApplyToDocumentPost']
      >
    >
  >;
export type GetDocumentTypeFilterKeysDocumentFiltersDocumentTypesPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getDocumentTypeFilterKeysDocumentFiltersDocumentTypesPost']
      >
    >
  >;
export type GetDocumentsByBatchIdDocumentGetDocumentsByBatchIdBatchIdGetResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['getDocumentsByBatchIdDocumentGetDocumentsByBatchIdBatchIdGet']
      >
    >
  >;
export type GetRelatedDocumentsDocumentRelatedPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getDocument>['getRelatedDocumentsDocumentRelatedPost']
    >
  >
>;
export type ExportDashboardDataDocumentExportsDashboardPostResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getDocument
      >['exportDashboardDataDocumentExportsDashboardPost']
    >
  >
>;
export type UpdatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['updatePendingWorkflowDocumentUpdatePendingWorkflowDocIdPost']
      >
    >
  >;
export type CreateDashboardExportRequestDocumentExportsRequestsPostResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getDocument
        >['createDashboardExportRequestDocumentExportsRequestsPost']
      >
    >
  >;
